import {
  SIZE_SCALE,
  PADDING_Y,
  SHADOW_SCALE,
  COLOR_SCALE,
  RADIUS_SCALE,
} from '@/components/design-system/tokens';

// Common popover styling constants
export const POPOVER_STYLES = {
  standard: `${SIZE_SCALE.w64} ${PADDING_Y['4']} ${COLOR_SCALE.surface} ${RADIUS_SCALE.xl} ${SHADOW_SCALE.lg} ${COLOR_SCALE.border}`,
  wide: `w-80 ${PADDING_Y['4']} ${COLOR_SCALE.surface} ${RADIUS_SCALE.xl} ${SHADOW_SCALE.lg} ${COLOR_SCALE.border}`,
  small: `${SIZE_SCALE.w56} ${PADDING_Y['4']} ${COLOR_SCALE.surface} ${RADIUS_SCALE.xl} ${SHADOW_SCALE.lg} ${COLOR_SCALE.border}`,
};
